import BackgroundBlue from '@/components/Icons/BackgroundBlue';
import React, { Children, Fragment, PropsWithChildren } from 'react';
import Div from './Div';
import classNames from 'classnames';
import FixedWrapper from './FixedWrapper';
import Button from './Button';
import CheckCircle from '@/components/Icons/CheckCircle';

type GeneralSuccessScreenProps = {
  className?: string;
  showButton?: boolean;
  buttonText?: string;
  href?: string;
  onClick?: () => void;
};

function GeneralSuccessScreen({
  className,
  children,
  showButton = false,
  buttonText,
  href,
  onClick,
}: PropsWithChildren<GeneralSuccessScreenProps>) {
  return (
    <Div className="flex bg-gradient-to-b from-blue-100 to-cs-primary justify-center">
      <Div
        className={classNames(
          'mt-s11 mx-s9 flex flex-col gap-s6 items-center w-[300px] md:w-[338px] justify-center',
          className,
        )}
      >
        <CheckCircle />
        {children}
        {showButton && buttonText ? (
          <Fragment>
            <Button href={href} className="m-s6 w-full hidden md:block" onClick={onClick}>
              {buttonText}
            </Button>
            <FixedWrapper className="md:hidden p-s5 pb-s6">
              <Button href={href} onClick={onClick} className="w-full ">
                {buttonText}
              </Button>
            </FixedWrapper>{' '}
          </Fragment>
        ) : null}
      </Div>
    </Div>
  );
}

export default GeneralSuccessScreen;
